var config = {
  isLocal: !(process.env.NEXT_PUBLIC_CONTENTFUL_API_ENVIRONMENT === 'master' && process.env.NODE_ENV === 'production')
};
export default config;